import { Injectable } from '@angular/core';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { QuantiteDossierByEmployeeDTO } from '../model/quantite-dossier-by-employee-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { DashboardDossierModel } from '../model/DashboardDossierModel';
import { DashboardDossierStatut } from '../model/DashboardDossierStatut';
import { DashboardDossierNombre } from '../model/DashboardDossierNombre';
import { DashboardDossierProduit } from '../model/DashboardDossierProduit';
import { DashboardDossierCredit } from '../model/DashboardDossierCredit';
import { QuantiteDossierByPeriodeDTO } from '../model/quantite-dossier-by-periode-dto';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';

@Injectable({
    providedIn: 'root'
  })
  export class NewDashboardCorporateService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    //Corpoate
    getDashboardCorpoateProduction() {
      return this._restClientService.load<DashboardDossierModel[]>('new-dashboard-marche/corpoate-by-statut');
    }
   
    getDossiersByStatutAndProfil() {
      return this._restClientService.load<DashboardDossierStatut[]>('new-dashboard-marche/dossiers-by-profil');
    }

  getDossiersByStatutAndProfilGlobal() {
    return this._restClientService.load<DashboardDossierStatut[]>(
      "new-dashboard-credit/dossiers-by-profil"
    );
  }
    getTotalDossierByTimePeriod(workflow: string) {
      return this._restClientService.load<DashboardDossierNombre>(`new-dashboard-marche/dossiers-nombre?workflow=${workflow}`);
    }
    //Credits
    /********* CREDIT PRODUCTION STATS **************/
    getDashboardCreditProduction() {
      return this._restClientService.load<DashboardDossierModel[]>('new-dashboard-credit/credit-by-statut');
    }
    getDossiersCreditByProfil() {
      return this._restClientService.load<DashboardDossierStatut[]>('new-dashboard-credit/dossiers-by-profil');
    }
    getDossiersCreditByStatutAndProduit() {
      return this._restClientService.load<DashboardDossierProduit[]>('new-dashboard-credit/dossiers-by-statut-and-produit');
    }


    /********* CREDIT CARD VIEW **************/
    getDossiersCorporateStatus(filter: string, pageIndex: number, pageSize: number): any {
      return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-corporate/dossiers-corporate-status?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
    }
    getDossiersCreditEnCours(filter: string, pageIndex: number, pageSize: number): any {
      return this._restClientService.load<DashboardDossierCredit[]>(`new-dashboard-credit/dossiers-credit-en-cours?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
    }

    getDossiersCreditEnRetard(filter: string, pageIndex: number, pageSize: number): any {
      return this._restClientService.load<DashboardDossierCredit[]>(`new-dashboard-credit/dossiers-credit-en-retard?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
    }

    getDossiersCreditMiseEnPlace(filter: string, pageIndex: number, pageSize: number): any {
      return this._restClientService.load<DashboardDossierCredit[]>(`new-dashboard-credit/dossiers-credit-mise-en-place?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
    }
    
    getDossiersCreditEnCorrection(filter: string, pageIndex: number, pageSize: number): any {
      return this._restClientService.load<DashboardDossierCredit[]>(`new-dashboard-credit/dossiers-credit-en-correction?filter=${filter}&page=${pageIndex}&size=${pageSize}`);
    }


    quantiteDossierByPeriodeAndAgence(codeAgence) 
    {
        return this._restClientService.load<QuantiteDossierByPeriodeDTO>('dashboard-corporate/quantite-dossier-by-periode-and-agence?codeagence='+codeAgence);
    }
    
    
    slaProduitParPeriode()
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-corporate/sla-produit-par-periode');
    }
    
    quantiteDossierByEmployee() 
    {
        return this._restClientService.load<QuantiteDossierByEmployeeDTO[]>('dashboard-corporate/quantite-dossier-by-employee');
    }


    
    montantDossierStatutSurLes6DerniersMois(codeAgence) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-corporate/montant-dossier-statut-sur-les-6-derniers-mois?codeagence='+codeAgence);
    }

    quantiteDossierStatutSurLes6DerniersMois(codeAgence) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-corporate/quantite-dossier-statut-sur-les-6-derniers-mois?codeagence='+codeAgence);
    }
    

}